import styled from "styled-components";

const DescriptionDiv = styled.div`
  position: absolute;
  z-index: 1;
  top: 60px;
  right: 80px;
  color: #fff;

  @media(max-width:767px){
    top: 30px;
    right: 30px
  }
`;
export default DescriptionDiv;
